import React from 'react';
import { motion } from 'framer-motion';
interface SectionWrapperProps {
  children: ReactNode;
  className?: string;
  delay?: number;
  id?: string;
}
export function SectionWrapper({
  children,
  className = '',
  delay = 0,
  id
}: SectionWrapperProps) {
  return <motion.div id={id} initial={{
    opacity: 0,
    y: 40,
    scale: 0.98,
    filter: 'blur(4px)'
  }} whileInView={{
    opacity: 1,
    y: 0,
    scale: 1,
    filter: 'blur(0px)'
  }} viewport={{
    once: true,
    margin: '-80px'
  }} transition={{
    duration: 0.8,
    ease: [0.25, 0.1, 0.25, 1],
    delay: delay
  }} className={`relative ${className}`} data-id="element-257">
      {children}
    </motion.div>;
}